<template>
  <div>
    <b-row>
      <b-col lg="12">
        <div class="text-center p-5 row" v-if="isLoading">
          <semipolar-spinner :animation-duration="2000" :size="80" color="#63c2de" class="offset-6"></semipolar-spinner>
        </div>
        <table-ads-accounts
          :table-data="items"
          :fields="fields"
          caption=" <h4><i class='fas fa-ad mr-2'></i> Cuentas Ads</h4>"
          v-else
        ></table-ads-accounts>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { shuffleArray } from "@/shared/utils";
import TableAdsAccounts from "./TableAdsAccounts";
import store from "../../store";
import { SemipolarSpinner } from "epic-spinners";

import {
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput
} from "mdbvue";

export default {
  name: "facebookPages",
  components: {
    TableAdsAccounts,
    SemipolarSpinner,
    mdbContainer,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter,
    mdbRow,
    mdbBtn,
    mdbIcon,
    mdbTextarea,
    mdbInput
  },
  data: () => {
    return {
      items: [],
      itemsArray: [],
      fields: [
        { key: "name", label: "Nombre", sortable: true },
        { key: "account_id", label: "ID cuenta", sortable: true },
        { key: "account_status", label: "Status de cuenta", sortable: true },
        { key: "business_name", label: "Nombre de Bussiness", sortable: true },
        { key: "acciones", label: "Acciones" }
      ],
      isLoading: false
    };
  },
  mounted() {
    this.getAdsAccounts();
  },
  methods: {
    getAdsAccounts() {
      var ads = store.getters.getAdsAccounts;
      if (ads.length == 0) {
        this.isLoading = true;
        store.dispatch("getAdsAccounts").then(() => {
          ads = store.getters.getAdsAccounts;
          shuffleArray([ads]);
          this.isLoading = false;
          this.items = ads;
          this.itemsArray = ads;
        });
      } else {
        shuffleArray([ads]);
        this.items = ads;
        this.itemsArray = ads;
      }
    }
  }
};
</script>
